module.exports = __webpack_public_path__ + "img/skype.573e4b08.svg";